import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

const dedupe = (input: string) => input
  .split(' ')
  .filter(Boolean)
  .reduceRight((acc: string[], cls) => {
    if (!acc.includes(cls)) {
      acc.unshift(cls);
    }

    return acc;
  }, [])
  .join(' ')

export function cn(...inputs: ClassValue[]) {
  return twMerge(dedupe(clsx(inputs)));
}
